import { Image } from 'expo-image';
import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import IllustrationMap from 'shared/components/vxl/Illustration/IllustrationMap';

export type IllustrationKeyType = keyof typeof IllustrationMap;
export type IllustrationURL = { uri: string };

export type IllustrationSourceType = IllustrationKeyType | IllustrationURL;

export interface IllustrationProps {
  /** The illustration key is used to render a specific illustration from the VXL illustration library. */
  illustration: IllustrationSourceType;
  accessibilityLabel?: string;
}

const Illustration = ({
  illustration,
  accessibilityLabel = 'illustration',
}: IllustrationProps) => {
  const [error, setError] = useState(false);
  const illustrationFromKey =
    IllustrationMap[illustration as IllustrationKeyType];

  return (
    <Image
      style={imageStyles.wrapper}
      source={
        illustrationFromKey
          ? illustrationFromKey
          : (illustration as IllustrationURL)
      }
      placeholder={
        error || illustrationFromKey
          ? undefined
          : IllustrationMap.LOADING_CIRCLE_STATIC
      }
      contentFit="contain"
      onError={() => {
        setError(true);
      }}
      accessible
      accessibilityLabel={accessibilityLabel}
      role="img"
    />
  );
};

const imageStyles = StyleSheet.create({
  wrapper: { height: '100%', width: '100%' },
});

export default Illustration;
